import {
  AlertVariant,
  useAlert,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Alert';
import { Button } from '@mui/material';

const Sandbox: React.FC = () => {
  const [, { openAlert }] = useAlert();
  const handleClick = () => {
    openAlert({
      body: 'TEST',
      variant: AlertVariant.SUCCESS,
    });
  };
  return (
    <>
      <Button onClick={handleClick}>openAlert</Button>
    </>
  );
};

export default Sandbox;
